module.exports = __webpack_public_path__ + "img/about-5.5eb859b0.jpg";